import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3d729cfe"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "text-fa"
};
const _hoisted_2 = {
  class: "text-title"
};
const _hoisted_3 = {
  class: "title-tips"
};
const _hoisted_4 = {
  class: "text-cont-fa"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LaborDetailTitleValue = _resolveComponent("LaborDetailTitleValue");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.moudleName), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_LaborDetailTitleValue, {
    title: "实验目的",
    value: $props.laboratoryItemDetail.experiment_purpose || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "实验课时",
    value: $props.laboratoryItemDetail.period || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "实验原理",
    value: $props.laboratoryItemDetail.experiment_theory || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "实验仪器设备",
    value: $props.laboratoryItemDetail.experiment_equipment || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "实验教学方法",
    value: $props.laboratoryItemDetail.experiment_method || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "实验方法与步骤要求",
    value: $props.laboratoryItemDetail.experiment_step || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "实验结果与结论要求",
    value: $props.laboratoryItemDetail.experiment_result || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "考核要求",
    value: $props.laboratoryItemDetail.experiment_check || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "考核面向学生要求",
    value: $props.laboratoryItemDetail.experiment_stu_check || '-'
  }, null, 8, ["value"]), _createVNode(_component_LaborDetailTitleValue, {
    title: "实验项目应用及其共享情况",
    value: $props.laboratoryItemDetail.experiment_state || '-'
  }, null, 8, ["value"])])]);
}